import { render, staticRenderFns } from "./StopElement.vue?vue&type=template&id=4de124e5&scoped=true&"
import script from "./StopElement.vue?vue&type=script&lang=js&"
export * from "./StopElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de124e5",
  null
  
)

export default component.exports